import { useContext } from 'react';
import { Rectangle, Popup } from 'react-leaflet';
import { MapContext, useEventTodo, ViewOnlyContext } from '../context';
import { db } from '../instant';
import { Typography, Stack, Checkbox, Divider, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import L from 'leaflet';

export default function SweepTodosLayer() {
    const { eventId, cleanupMode, mapNumber, notesOnlyFilter } = useContext(MapContext);
    const viewOnly = useContext(ViewOnlyContext);
    const { todo: todos } = useEventTodo(eventId);

    if (!todos) return null;
    if (notesOnlyFilter) return null;

    const sweepTodos = todos.filter(t => {
        if (!t.areaCoordinates || t.completed) return false;

        const parsed = JSON.parse(t.areaCoordinates as string);
        if (parsed.mapNumber !== undefined) {
            return parsed.mapNumber === mapNumber;
        }
        return true;
    });

    const handleDelete = (todoId: string) => {
        db.transact(db.tx.todos[todoId].delete());
    };

    const handleToggleComplete = async (ev: React.MouseEvent, todoId: string, currentCompleted: boolean) => {
        ev.stopPropagation();
        await db.transact(db.tx.todos[todoId].update({ completed: !currentCompleted }));
    };

    return (
        <>
            {sweepTodos.map(todo => {
                try {
                    const parsed = JSON.parse(todo.areaCoordinates as string);
                    const bounds = parsed.bounds || parsed;
                    let latLngBounds: L.LatLngBoundsExpression;
                    if (bounds._southWest && bounds._northEast) {
                        latLngBounds = [
                            [bounds._southWest.lat, bounds._southWest.lng],
                            [bounds._northEast.lat, bounds._northEast.lng],
                        ];
                    } else {
                        latLngBounds = bounds;
                    }

                    return (
                        <Rectangle
                            key={todo.id}
                            bounds={latLngBounds}
                            pathOptions={{ color: (todo.todoType?.color as string) || '#FFA726', weight: 2, fillOpacity: 0.2 }}
                        >
                            {!cleanupMode && (
                                <Popup>
                                    <Stack sx={{ alignItems: 'center' }} direction="column" spacing={1}>
                                        <Typography fontWeight="bold" style={{ margin: '5px' }}>
                                            {(todo.todoType?.name as string) || 'Litter Sweep'}
                                        </Typography>
                                        <Divider flexItem />
                                        <Stack sx={{ alignItems: 'center', width: '100%' }} direction="row" spacing={1}>
                                            <Checkbox
                                                checked={todo.completed as boolean}
                                                onClick={ev => handleToggleComplete(ev, todo.id, todo.completed as boolean)}
                                                disabled={viewOnly}
                                                sx={{ padding: 0 }}
                                            />
                                            <Typography fontWeight="bold" sx={{ flex: 1 }}>
                                                TODO: {(todo.todoType?.name as string) || 'Sweep Area'}
                                            </Typography>
                                            {!viewOnly && (
                                                <IconButton size="small" color="error" onClick={() => handleDelete(todo.id)}>
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            )}
                                        </Stack>
                                        {todo.notes ? (
                                            <Typography variant="body2" color="text.secondary" sx={{ width: '100%', textAlign: 'left' }}>
                                                {todo.notes as string}
                                            </Typography>
                                        ) : null}
                                    </Stack>
                                </Popup>
                            )}
                        </Rectangle>
                    );
                } catch (e) {
                    console.error('Failed to parse area coordinates for todo', todo.id, e);
                    return null;
                }
            })}
        </>
    );
}
